export enum Permission {
  VIEW     = 1,
  ADD      = 2,
  EDIT     = 4,
  DELETE   = 8,
  VALIDATE = 16,
  OVERRIDE = 32
}
